import Cookies from "js-cookie";

document.addEventListener("DOMContentLoaded", function () {
  // header banner
  const headerBanner = document.querySelector(".header-banner");

  if (headerBanner) {
    const closeBtn = headerBanner.querySelector(".header-banner--close");

    closeBtn.addEventListener("click", () => {
      Cookies.set("hide_header_banner", "1", {
        expires: 7,
        sameSite: "Lax",
      });

      headerBanner.remove();
    });
  }
});
